<div (click)="sendClose()" class="backdrop"></div>

<div class="sidebar-panel">
  <div class="content">
    <span class="d-flex justify-end cross-float">
      <span (click)="sendClose()" class="picto-close picto-size-6 font-semibold cursor-pointer"></span>
    </span>
    <ng-content></ng-content>
  </div>
</div>
